import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { Typography, Divider, Paper, Grid, Box, Button, TextField } from '@mui/material';
import { useSnackbar } from 'notistack';
import Modal from 'components/Modal';
import ReactDataGrid from '@inovua/reactdatagrid-community'
import '@inovua/reactdatagrid-community/index.css'
import { LocalizationProvider, MobileDateRangePicker } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { getDbFormat } from 'utils/common';
import { isValid } from 'date-fns';
import { getActivityLog } from 'services/activityLog';
import LogDataModal from './LogDataModal';

const ActivityLogPage = () => {

  const gridStyle = useMemo(() => ({ minHeight: 480, width: '100%' }), []);
  const [ filterDates, setFilterDates] = React.useState([new Date(), new Date()]);
  const [modalLogData, setModalLogData] = useState(null);
  const [ pageFilters, setPageFilters] = React.useState({filterDates});
  const [gridRef, setGridRef] = useState(null);

  const [logData, setLogData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  function onDateAccepted(data) {
    const [fromDate,  toDate] = data;
    if(isValid(fromDate) && isValid(toDate)) {
      setFilterDates(data);
      setPageFilters({...pageFilters, filterDates: data});
    }else{
      enqueueSnackbar(`Select ${fromDate === null ? 'From Date' : 'To Date'}`, {variant: 'error'});
    }
  }


  // const defaultFilterValue = [
  //   { name: 'Property', operator: 'contains', type: 'string', value: '' },
  //   { name: 'Vendor', operator: 'contains', type: 'string', value: '' },
  //   { name: 'description', operator: 'contains', type: 'string', value: '' },
  //   { name: 'Amount', operator: 'contains', type: 'string', value: '' },
  //   { name: 'createdOn', operator: 'contains', type: 'string', value: '' },
  // ];
  const columns = useMemo(() => ([
    { name: 'userName', header: 'User Name', sortable: false, defaultFlex: 1, minWidth: 140},
    { name: 'description', header: 'Description', sortable: false, defaultFlex: 1, minWidth: 240},
    { name: 'createdOn', header: 'Date', sortable: false, defaultFlex: 1, minWidth: 120},
    { name: 'log', header: 'Log', sortable: false, defaultFlex: 1, minWidth: 100, render: ({data} ) => { 
      return (
       <Button variant="contained" size="small" color="info" onClick={() => {setOpenModal(true); setModalLogData(data?.log) } }>Log Data</Button>
      ); 
    }},
  ]),[]);

  useEffect(() => {
    getLogData();
  }, []);

  function getLogData() {
    let [fromDate, toDate ]= pageFilters.filterDates;
    const from = getDbFormat(fromDate);
    const to = getDbFormat(toDate);
    const userType = 'ADMIN';

    getActivityLog({from, to, userType}).then(({response, error}) => {
      if(response){
        setLogData(response);
      } else {
        setLogData([]);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }


  const onModalClose = useCallback(
    () => {
      setOpenModal(false);
      setModalLogData(null);
    },
    [setOpenModal],
  )

  function onGoBtnClick() {
    if(!(pageFilters?.filterDates)){
      enqueueSnackbar("Select from date and to date", {variant: 'error'});
      return;
    }
    getLogData();
  }

  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
      <Typography component="h2" variant="h6" color="secondary" gutterBottom sx={{mb: 1}}>
        Activity Log
      </Typography>
      <Divider />
      <Box noValidate  sx={{ mt: 2 }} >
        <Grid container>
          <Grid container item xs={12} sm={12} md={12} xl={12} lg={12} sx={{p:1, bgcolor: "#f3f3f3"}}>
            <Typography variant="subtitle2" gutterBottom component="div">
              Filters
            </Typography>
            <Grid container item xs={12} sm={12} md={12} xl={12} lg={12} columnSpacing={1}>
              <Grid item sx={{mt: 2}} xs={12} sm={12} md={4} xl={4} lg={4}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <MobileDateRangePicker
                    inputFormat="dd/MM/yyyy"
                    startText="From Date"
                    endText="To Date"
                    value={filterDates}
                    // clearable={true}
                    onChange={(newValue) => {
                      // setFilterDates(newValue);
                    }}
                    onAccept={(data) => onDateAccepted(data)}
                    renderInput={(startProps, endProps) => (
                      <React.Fragment>
                        <TextField {...startProps} size="small" onKeyDown={(e) => {e.preventDefault();return false}}/>
                        <Box sx={{ mx: 2 }}> to </Box>
                        <TextField {...endProps} size="small" onKeyDown={(e) => {e.preventDefault();return false}} />
                      </React.Fragment>
                    )}
                    />
                </LocalizationProvider>
              </Grid>
              <Grid item sx={{pt: 2, }} xs={4} sm={2} md={2} xl={2} lg={2}>
                <Button variant="contained" onClick={onGoBtnClick} sx={{textTransform:'none', fontSize: 14, py: '7px'}}>Go</Button>
              </Grid>
            </Grid>
          </Grid>
    
          <Grid item xs={12} sm={12} md={12} lg={12} >
            <Box component="div" sx={{  mt: 3 ,  maxHeight: 720, width: '100%' }}>
              <ReactDataGrid
                handle={setGridRef}
                idProperty="id"
                style={gridStyle}
                // defaultFilterValue={defaultFilterValue}
                columns={columns}
                dataSource={logData}
                rowHeight={null} 
                minRowHeight={50}
              />
            </Box>
          </Grid>
        </Grid>
      </Box> 
      <Modal maxWidth={"lg"} open={openModal} onModalClose={onModalClose} title={'Log Data'}>
        <LogDataModal  data={modalLogData} />
      </Modal>
    </Paper>
  );
}
 
export default ActivityLogPage;
